import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import Selection from 'src/components/Selection/Selection';
import { useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import { EventMarketItemType } from 'src_common/common/websocket2/modelsApi/EventMarkets';

interface RenderEventsRowPropsType {
    market: EventMarketItemType | undefined;
    userId: number;
    eventName: string;
    onEventClick: (eventId: number) => void;
}

export const RenderEventsRow = observer(
    'RenderEventsRow',
    (props: RenderEventsRowPropsType): React.ReactElement | null => {
        const { userId, market, eventName, onEventClick } = props;
        const appState = useAppStateContext();
        const selectedEventId = appState.routerBackoffice.getParametersNumber('customers', 'event');

        const marketModel = market?.id2.getModel();
        const eventModel = marketModel?.getEvent();
        if (eventModel === null || eventModel === undefined) {
            return null;
        }
        const eventId = eventModel.id;
        const startTime = eventModel.convertToSmallEvent().startTime;

        return (
            <tr
                key={eventId}
                onClick={(): void => onEventClick(eventId)}
                className={classNames({
                    'two-participants-events-item': true,
                    active: eventId === selectedEventId,
                })}
                data-test-event-id={eventId}
                data-test='event-row'
            >
                <td className='time'>
                    <span className='event-row__date'>{moment(startTime).format('DD MMM')}</span>
                    <span className='event-row__time'>{moment(startTime).format('HH:mm')}</span>
                </td>
                <td
                    className='name'
                    data-test='event-name'
                >
                    {eventName}
                </td>

                {marketModel?.selectionsIds2.map((selectionId) => {
                    return (
                        <td
                            key={selectionId.key}
                            className='selection'
                        >
                            <Selection
                                userId={userId}
                                marketId={marketModel.id}
                                selectionId={selectionId.toOldId()}
                            />
                        </td>
                    );
                })}
            </tr>
        );
    }
);
